import { isArray } from 'lodash';
import SEMRushWebsiteTrafficController from '../controllers/SEMRushWebsiteTrafficController';
import commonHandler from '../errorHandlers/common-handler';
import { getActionHookBuilder } from './action-hook-builder';
import websiteReportSummaryActions from './WebsiteReportSummaryActions';

const SEMRushWebsiteTrafficActions = {
  retriveTotalsByDomain(
    domain: string,
    ipAdress?: string,
    countryCode?: string,
  ) {
    return async dispatch => {
      try {
        dispatch(websiteReportSummaryActions.setTrafficBusy(true));
        return await SEMRushWebsiteTrafficController.getTotalsByDomain(
          domain,
          ipAdress,
          countryCode,
        );
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(websiteReportSummaryActions.setTrafficLoaded(true));
      }
    };
  },

  retriveMonthlyByDomain(domain: string, ipAdress?: string) {
    return async dispatch => {
      try {
        return await SEMRushWebsiteTrafficController.getMonthlyByDomain(
          domain,
          ipAdress,
        );
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },

  retriveCompetitorsByDomain(domain: string) {
    return async dispatch => {
      try {
        const res = await SEMRushWebsiteTrafficController.getCompetitors(
          domain,
        );
        return isArray(res) ? res : [];
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },

  retriveSummaryByDomain(domain: string) {
    return async dispatch => {
      try {
        return await SEMRushWebsiteTrafficController.getSummary(domain);
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },

  retriveTopLandingsByDomain(domain: string, displayDate?: string) {
    return async dispatch => {
      try {
        return await SEMRushWebsiteTrafficController.getTopPages(
          domain,
          displayDate,
        );
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },
};

export const useSEMRushWebsiteTrafficCRUDActions = getActionHookBuilder(
  SEMRushWebsiteTrafficActions,
  [
    'retriveTotalsByDomain',
    'retriveMonthlyByDomain',
    'retriveCompetitorsByDomain',
    'retriveSummaryByDomain',
    'retriveTopLandingsByDomain',
  ],
);
